class ProductsFavorite {

    constructor(element) {

        this.element = $(element);

        this.events();

    }

    events() {

        let self = this;

        $(document).on('click', '.product-favorite', function (e) {
            e.preventDefault();

            let productId = $(this).data('product-id');

            if (!$(this).hasClass("is-favorite")) {
                $(this).addClass("is-favorite");

                self.add(productId);

            } else {
                $(this).removeClass("is-favorite");

                self.removeCard(this);
                self.remove(productId);
            }
        });

    }

    add(productId) {

        $.ajax({
            url: config.domain + '/frontend/functions/products_favorite_add.php',
            type: 'post',
            data: {
                "product_id": productId
            },
            dataType: 'json',
            success: function (response) {

                if (response.count == 1) {
                    $('.favorite-count').html('<i class="fas fa-heart mr-2"></i>' + response.count + ' ' + $('.favorite-count').data('single'));
                    $('.favorite-count').addClass('active');

                }
                else {
                    $('.favorite-count').html('<i class="fas fa-heart mr-2"></i>' + response.count + ' ' + $('.favorite-count').data('multiple'));
                }

            }
        });
    }

    remove(productId) {
        $.ajax({
            url: config.domain + '/frontend/functions/products_favorite_remove.php',
            type: 'post',
            data: {
                "product_id": productId
            },
            dataType: 'json',
            success: function (response) {
                console.log(response);

                let count = response.count;
                if (response.count == 0) {
                    $('.favorite-count').removeClass('active');
                    $('.no-favorites').removeClass('d-none');
                    count = "";
                }

                if (response.count == 1) {
                    $('.favorite-count').html('<i class="fas fa-heart mr-2"></i>' + count + ' ' + $('.favorite-count').data('single'));
                }
                else {
                    $('.favorite-count').html('<i class="fas fa-heart mr-2"></i>' + count + ' ' + $('.favorite-count').data('multiple'));

                }



            }
        });
    }

    removeCard(element) {
        console.log($(element).data('remove-card'))
        console.log($(element).closest('.card').parent())
        if ($(element).data('remove-card')) {
            $(element).closest('.card').parent().remove();
        }
    }
}
